
export const getIsMobile = () => {
  return window.matchMedia('(max-width: 767px)').matches;
}
